// export const CHANNEL_SUBMIT = 'submit';
// export const ON_INPUT = 'input_change';
/** ITG_RENDER_CHANNEL is going to be deprecated. Use FE_RENDER_CHANNEL instead */
export var ITG_RENDER_CHANNEL = 'itg_render_channel';
export var FE_RENDER_CHANNEL = 'itg_render_channel';
//# sourceMappingURL=channel.js.map